import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Stakeholders by Understanding/Readiness',
      type: 'charts',
      alias: 'stakeholders-by-understanding-readiness',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Understanding',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Stakeholders',
                          color: '#2F5DA8',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'High',
                                  y: {
                                    '#': {
                                      '@': 'highUnderstandingStakeholders',
                                    },
                                  },
                                  name: 'High',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      understanding: 'High',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Medium',
                                  y: {
                                    '#': {
                                      '@': 'mediumUnderstandingStakeholders',
                                    },
                                  },
                                  name: 'Medium',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      understanding: 'Medium',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Low',
                                  y: {
                                    '#': {
                                      '@': 'lowUnderstandingStakeholders',
                                    },
                                  },
                                  name: 'Low',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      understanding: 'Low',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Unknown',
                                  y: {
                                    '#': {
                                      '@': 'unknownUnderstandingStakeholders',
                                    },
                                  },
                                  name: 'Unknown',
                                  onClick: {
                                    '{}': {
                                      action: {
                                        '{}': {
                                          payload: {
                                            '{}': {
                                              goto: {
                                                '{}': {
                                                  variables: {
                                                    '{}': {
                                                      understanding: 'Unknown',
                                                    },
                                                  },
                                                  navigationId:
                                                    'stakeholder.log',
                                                },
                                              },
                                            },
                                          },
                                          operation: 'ui.navigate',
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Understanding Level',
                  yLabel: 'Stakeholders',
                  description:
                    'Stakeholder count by understanding of the change. Unknown includes unassessed stakeholders.',
                },
              },
            ],
          },
          type: 'bar',
          config: {
            '{}': {
              yAxis: {
                '{}': {
                  min: 0,
                  tickInterval: 1,
                  allowDecimals: false,
                },
              },
            },
          },
        },
      },
    },
  },
  subqueries: {
    lowUnderstandingStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!understanding',
          },
          'Low',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    highUnderstandingStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!understanding',
          },
          'High',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    mediumUnderstandingStakeholders: {
      filter: {
        '=': [
          {
            '@.': '!understanding',
          },
          'Medium',
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
    unknownUnderstandingStakeholders: {
      filter: {
        or: [
          {
            '=': [
              {
                '@.': '!understanding',
              },
              'Unknown',
            ],
          },
          {
            '=': [
              {
                '@.': '!understanding',
              },
              null,
            ],
          },
          {
            '=': [
              {
                '@.': '!understanding',
              },
              '',
            ],
          },
        ],
      },
      target: 'ent:!stakeholders:!stakeholder',
      selection: {
        '@.': '!id',
      },
    },
  },
}
